import React from "react";
import Container from "react-bootstrap/Container";
import Inicio from "./views/Inicio";
import Login from "./views/Login";
import Perfil from "./views/Perfil";
import firebaseApp from "./firebase/credenciales";
import getRecordFromFirestore from './functions/getRecordFromFirestore';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const auth = getAuth(firebaseApp);
const firestore = getFirestore(firebaseApp);

function App() {
  const [usuario, setUsuario] = React.useState(null);
  const [mustChangePassword, setMustChangePassword] = React.useState(false);
  const [authError, setAuthError] = React.useState(""); // State for global auth errors
  const collectionName = 'users';
  const campoName = 'email';

  const normalizeEnabledCompanies = (usuarioDB) => {
    const raw =
      usuarioDB?.empresasHabilitadas ??
      usuarioDB?.empresasIds ??
      usuarioDB?.empresasIDs ??
      usuarioDB?.rucs ??
      usuarioDB?.companyIds ??
      [];

    const baseList = Array.isArray(raw)
      ? raw
      : typeof raw === 'string' && raw.trim()
        ? raw.split(',')
        : [];

    const withCurrent = [
      ...baseList,
      usuarioDB?.rucEmpresa,
      usuarioDB?.ruc
    ];

    return [...new Set(withCurrent.map((value) => String(value || '').trim()).filter(Boolean))];
  };

  async function setUserWithFirebaseAndRol(usuarioFirebase) {
    try {
      console.log("🔍 Iniciando carga de datos del usuario:", usuarioFirebase.email);

      // Obtener datos del usuario
      const usuarioDB = await getRecordFromFirestore(collectionName, campoName, usuarioFirebase.email);

      // CRITICAL FIX: Handle case where user exists in Auth but not in Firestore
      if (!usuarioDB) {
        console.warn("⚠️ Usuario autenticado pero no encontrado en Firestore.");
        setAuthError("Tu cuenta es válida, pero no tienes un registro de usuario asociado en el sistema. Contacta a RRHH.");
        await auth.signOut(); // Force sign out to reset state
        setUsuario(null);
        return;
      }

      // Obtener datos de la empresa usando el RUC del usuario
      let empresaData = null;
      if (usuarioDB.rucEmpresa) {
        try {
          const empresaRef = doc(firestore, 'company', usuarioDB.rucEmpresa);
          const empresaSnap = await getDoc(empresaRef);

          if (empresaSnap.exists()) {
            empresaData = empresaSnap.data();
          } else {
            console.warn(`❌ No se encontró empresa con RUC: ${usuarioDB.rucEmpresa}`);
          }
        } catch (error) {
          console.error('❌ Error al obtener datos de la empresa:', error);
        }
      } else {
        console.warn("⚠️ El usuario no tiene rucEmpresa definido");
      }

      // Construir objeto usuario con datos de la empresa
      const userData = {
        uid: usuarioFirebase.uid,
        //activo: usuarioDB.activo,
        cargo: usuarioDB.cargo,
        contrato: usuarioDB.contrato,
        direccion: usuarioDB.direccion,
        dni: usuarioDB.dni,
        email: usuarioFirebase.email,
        fechaCreacion: usuarioDB.fechaCreacion,
        legajo: usuarioDB.legajo,
        phone: usuarioDB.phone,
        recursosHumanos: usuarioDB.recursosHumanos,
        ruc: usuarioDB.rucEmpresa,
        nombre: usuarioDB.name,
        apellidos: usuarioDB.apellidos,
        rol: usuarioDB.rol,
        permisos: usuarioDB.permisos || null,
        supervisor: usuarioDB.supervisor,
        vacaciones: usuarioDB.vacaciones,
        empresasHabilitadas: normalizeEnabledCompanies(usuarioDB),
        // Datos de la empresa
        empresa: usuarioDB.empresa || empresaData?.name || empresaData?.razonSocial || empresaData?.nombreComercial || empresaData?.empresa || null,
        empresaNombreComercial: empresaData?.nombreComercial || empresaData?.name || null,
        empresaLogo: empresaData?.logo || null,
        empresaActivo: empresaData?.activo || null,
        datosEmpresa: empresaData || null
      };

      setUsuario(userData);
      setMustChangePassword(Boolean(usuarioDB.mustChangePassword));
      setAuthError(""); // Clear any previous errors on success
    } catch (error) {
      console.error('❌ Error general al obtener datos del usuario:', error);
      setAuthError("Error del sistema al cargar tu perfil. Intenta nuevamente.");
      await auth.signOut();
      setUsuario(null);
    }
  }

  // FIX: Move auth listener to useEffect to prevent memory leaks and loops
  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (usuarioFirebase) => {
      if (usuarioFirebase) {
        // Only fetch if we don't have the user data yet (or if we want to refresh)
        // Note: We check !usuario inside the effect generally, but setUserWithFirebaseAndRol is safe to call.
        // However, to avoid double-fetching if logic is complex, we trust the listener.
        await setUserWithFirebaseAndRol(usuarioFirebase);
      } else {
        setUsuario(null);
        setMustChangePassword(false);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <Container fluid>
      {usuario ? (
        mustChangePassword ? (
          <Perfil forcePasswordChange={true} onPasswordChanged={() => setMustChangePassword(false)} />
        ) : (
          <Inicio usuario={usuario} />
        )
      ) : <Login authError={authError} />}
    </Container>
  );
}

export default App;
